import { useState } from "react";
import { toast } from "sonner";
import { Mail, Phone, Instagram } from "lucide-react";
import { api, SOCIALS, PLATFORMS } from "@/lib/api";

export default function Contatti() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      toast.success("Messaggio inviato! Ti risponderemo presto.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch {
      toast.error("Errore nell'invio. Riprova.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="contatti-page">
      <section className="border-b border-[#2A2A2A]">
        <div className="max-w-7xl mx-auto px-5 lg:px-10 py-16">
          <p className="text-xs uppercase tracking-[0.25em] text-[#E4BD44] mb-4">Contatti</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight">Parliamone</h1>
        </div>
      </section>
      <section>
        <div className="max-w-7xl mx-auto px-5 lg:px-10 py-16 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <form onSubmit={submit} className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4" data-testid="contact-form">
            <input required className="ws-input" placeholder="Nome e cognome" value={form.name} onChange={set("name")} data-testid="contact-name" />
            <input required type="email" className="ws-input" placeholder="Email" value={form.email} onChange={set("email")} data-testid="contact-email" />
            <input className="ws-input sm:col-span-2" placeholder="Oggetto" value={form.subject} onChange={set("subject")} data-testid="contact-subject" />
            <textarea required rows={6} className="ws-input sm:col-span-2" placeholder="Il tuo messaggio" value={form.message} onChange={set("message")} data-testid="contact-message" />
            <div className="sm:col-span-2">
              <button type="submit" disabled={loading} className="btn-primary" data-testid="contact-submit">
                {loading ? "Invio…" : "Invia messaggio"}
              </button>
            </div>
          </form>
          <div className="lg:col-span-5">
            <div className="border border-[#2A2A2A] p-8 space-y-5">
              <h2 className="font-display text-2xl font-bold">Contatti diretti</h2>
              <p className="flex items-center gap-3 text-sm"><Phone size={16} className="text-[#E4BD44]" /> <a href="tel:+393284432930" className="ws-link">+39 328 443 2930</a></p>
              <p className="flex items-center gap-3 text-sm"><Mail size={16} className="text-[#E4BD44]" /> <a href="mailto:bewildwildbe@gmail.com" className="ws-link">bewildwildbe@gmail.com</a></p>
              <p className="flex items-center gap-3 text-sm"><Instagram size={16} className="text-[#E4BD44]" /> <a href="https://www.instagram.com/bedliw" target="_blank" rel="noopener noreferrer" className="ws-link">@bedliw (Italo Blandolino)</a></p>
              <div className="pt-4 border-t border-[#2A2A2A]">
                <p className="text-xs uppercase tracking-[0.2em] text-[#9a9484] mb-3">I nostri canali</p>
                <div className="flex flex-wrap gap-x-4 gap-y-1.5 text-xs">
                  {SOCIALS.map((s) => (
                    <a key={s.url} href={s.url} target="_blank" rel="noopener noreferrer" className="ws-link text-[#C9C4B8] hover:text-[#E4BD44]">
                      {s.handle}·{s.platform}
                    </a>
                  ))}
                  {PLATFORMS.map((p) => (
                    <a key={p.name} href={p.url} target="_blank" rel="noopener noreferrer" className="ws-link text-[#C9C4B8] hover:text-[#E4BD44]">
                      {p.name}
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
